import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/core/utils/utils";
import { PROSE_CLASS } from "./constants";
import { MathEquation } from "./math-equation";
import { remarkChatMath } from "./remark-chat-math";

const components: Components = {
  table: ({ node: _node, ...props }) => (
    <div className="overflow-x-auto">
      <table {...props} />
    </div>
  ),
  span: ({ node, ...props }) => {
    const source = node?.properties["data-chat-math"];
    return typeof source === "string" ? (
      <MathEquation
        source={source}
        complete={node?.properties["data-math-complete"] === true}
      />
    ) : (
      <span {...props} />
    );
  },
};

interface ChatMarkdownProps {
  children: string;
  streaming?: boolean;
}

export const ChatMarkdown = ({
  children,
  streaming = false,
}: ChatMarkdownProps) => (
  <div className={cn(PROSE_CLASS, "overflow-x-auto")}>
    <ReactMarkdown
      remarkPlugins={[
        remarkGfm,
        [remarkChatMath, { allowIncomplete: streaming }],
      ]}
      components={components}
    >
      {children}
    </ReactMarkdown>
  </div>
);
